import React from "react";
import { Delete, X } from "lucide-react";

const Key = ({ children, onClick, testid, ariaLabel, className = "" }) => (
  <button
    data-testid={testid}
    aria-label={ariaLabel}
    onClick={onClick}
    className={`keypad-key min-h-[68px] sm:min-h-[80px] rounded-2xl bg-white border border-border shadow-[0_6px_16px_rgba(2,6,23,0.08)] flex items-center justify-center font-display text-4xl font-semibold text-foreground ${className}`}
  >
    {children}
  </button>
);

export const GiantKeypad = ({ onDigit, onBackspace, onClear }) => {
  return (
    <div data-testid="numeric-keypad" className="grid grid-cols-3 gap-2.5 sm:gap-3 w-full">
      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((d) => (
        <Key
          key={d}
          testid={`keypad-key-${d}`}
          ariaLabel={`${d}`}
          onClick={() => onDigit(String(d))}
        >
          {d}
        </Key>
      ))}
      <Key testid="keypad-clear" ariaLabel="Очистить / Borrar todo" onClick={onClear} className="text-[hsl(var(--destructive))]">
        <X size={34} strokeWidth={2.5} />
      </Key>
      <Key testid="keypad-key-0" ariaLabel="0" onClick={() => onDigit("0")}>
        0
      </Key>
      <Key testid="keypad-backspace" ariaLabel="Стереть / Borrar" onClick={onBackspace} className="text-muted-foreground">
        <Delete size={34} strokeWidth={2.5} />
      </Key>
    </div>
  );
};
